import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { ChiSono } from "../components/ChiSono";
import { Servizi } from "../components/Servizi";
import { Booking } from "../components/BookingForm";
import { FreeSession } from "../components/FreeSession";
import { Safeguarding } from "../components/Safeguarding";
import { Contatti } from "../components/Contatti";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-[#08090C] min-h-screen text-slate-100">
      <Header />
      <main>
        <Hero />
        <ChiSono />
        <Servizi />
        <Booking />
        <FreeSession />
        <Safeguarding />
        <Contatti />
      </main>
      <Footer />
    </div>
  );
}
